import { render, staticRenderFns } from "./bottomFixed.vue?vue&type=template&id=2d79247c&scoped=true"
import script from "./bottomFixed.vue?vue&type=script&lang=js"
export * from "./bottomFixed.vue?vue&type=script&lang=js"
import style0 from "./bottomFixed.vue?vue&type=style&index=0&id=2d79247c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d79247c",
  null
  
)

export default component.exports